import type { Faq, OfferItem, Step, Testimonial } from '../types/offer'

export const modules: OfferItem[] = [
  {
    id: 'core',
    title: '48 Hrs AI Cash Machine',
    highlight: '(Sistema Central)',
    promise: 'Tu primer ingreso con AI en un plan de 48 horas',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/270a3dce-a326-4689-912a-50bb4bf2e67f.jpg',
    bullets: [
      'El proceso completo de 7 pasos: Targets, Marketing, Leads, Ventas y Escala — ya armado.',
      'Plantillas y prompts listos para copiar y ejecutar el mismo día.',
      'Pasos concretos y medibles, sin relleno y sin teoría que no aplicas.',
    ],
    value: '$497',
  },
  {
    id: 'closer',
    title: 'AI Web Closer Academy',
    promise: 'Cierra clientes de negocios locales con AI',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9a4aff1f-6ab6-4595-a3ff-459c6e9caecc.jpg',
    bullets: [
      'AI Prospecting Playbook + 90 Day AI Closing Blueprint paso a paso.',
      'Acceso al software AI Website Sales Accelerator para gestionar tus cierres.',
      'Local Business AI Scripts + AI Closer Elite Mastermind con la comunidad.',
    ],
    value: '$397',
  },
  {
    id: 'ads',
    title: 'Facebook Ads Expert',
    highlight: '(Mastery Course & Systems)',
    promise: 'Convierte la atención en clientes que pagan',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fff0cae2-f720-442a-b7c0-d1f2d42b9659.jpg',
    bullets: [
      'Targeting, creación de anuncios y lanzamiento — explicado paso a paso.',
      'Estructura de campaña y de presupuesto que ya funciona en el mercado.',
      'Optimización y escala basadas en datos reales, no en suposiciones.',
    ],
    value: '$297',
  },
  {
    id: 'websites',
    title: 'Build AI Websites',
    highlight: '(AI Website Builder System)',
    promise: 'Crea sitios web con AI en minutos, no en semanas',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/72eb1ea2-a398-4ab0-9112-d668028840f4.jpg',
    bullets: [
      'Sistema completo para construir sitios web profesionales usando AI.',
      'Plantillas de sitios incluidas y listas para personalizar.',
      'Un servicio que puedes vender a negocios locales desde el día uno.',
    ],
    value: '$297',
  },
  {
    id: 'creator',
    title: 'The Ultimate AI Creator Bundle',
    highlight: '(Imágenes y Videos)',
    promise: 'Produce imágenes y videos con AI de nivel profesional',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a2624af2-07c6-46c7-b34b-983926074e41.jpg',
    bullets: [
      'AI Image Generation Mastery + Isolated AI Video Production.',
      "Prompt Engineering Guide y AI Creator's Workbook para producir rápido.",
      'Automation & Workflow Secrets para crear contenido en serie.',
    ],
    value: '$247',
  },
  {
    id: 'brains',
    title: 'Custom AI Brains',
    highlight: '(Autopilot AI System)',
    promise: 'Tu asistente AI preprogramado para cada paso',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f3a46ea0-4769-4653-a36f-7d2c07b431f3.jpg',
    bullets: [
      'AI a la medida que maneja automatización, datos y ejecución por ti.',
      'Reportes y optimización sin que tengas que estar encima del proceso.',
      'Diseñado para que el sistema trabaje mientras tú te enfocas en vender.',
    ],
    value: '$259',
  },
]

export const bonuses: OfferItem[] = [
  {
    id: 'bonus-1',
    badge: 'BONO #1',
    title: 'Llamadas en Vivo Todos los Miércoles',
    promise: 'Acompañamiento directo durante 12 meses',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a2082bab-fd81-4d2c-93aa-7c87a6c81c7d.jpg',
    bullets: [
      'Sesión semanal en vivo para resolver tus dudas reales de ejecución.',
      'Revisión de tus anuncios, tu oferta y tus cierres en tiempo real.',
      'Acceso a la comunidad de quienes ya están ejecutando el sistema.',
    ],
    value: '$1,164',
  },
  {
    id: 'bonus-2',
    badge: 'BONO #2',
    title: 'Website Templates Con CRM Customized',
    promise: 'Plantillas de sitios web con CRM personalizado',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ee269c0e-8704-496c-8f83-35c0f0af6638.jpg',
    bullets: [
      'Plantillas de sitios web profesionales listas para personalizar y publicar.',
      'CRM personalizado integrado para capturar, organizar y dar seguimiento a tus leads.',
      'Todo conectado en un solo lugar para que empieces a operar esta misma semana.',
    ],
    value: '$497',
  },
  {
    id: 'bonus-3',
    badge: 'BONO #3',
    title: 'Comunidad Privada en SKOOL',
    promise: 'Acceso a la comunidad privada de 48 Hrs AI Cash Machine',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/938ce639-2768-41eb-b8d7-f449c1961118.jpg',
    bullets: [
      'Acceso a la comunidad privada de 48 Hrs AI Cash Machine en la aplicación SKOOL.',
      'Conecta con otros miembros que están ejecutando el mismo sistema.',
      'Comparte avances, resuelve dudas y mantente acompañado en cada paso.',
    ],
    value: '$297',
  },
]

export const steps: Step[] = [
  {
    number: '01',
    title: 'Define tu target',
    description:
      'Eliges el nicho de negocios locales con dinero y necesidad real. Sin adivinar a quién le vendes.',
  },
  {
    number: '02',
    title: 'Arma tu oferta con AI',
    description:
      'Usas los prompts para construir una oferta clara que se puede vender el mismo día.',
  },
  {
    number: '03',
    title: 'Monta tu activo digital',
    description:
      'Sitio web + CRM listos con plantillas. Se publica en horas, no en semanas.',
  },
  {
    number: '04',
    title: 'Genera leads',
    description:
      'Prospección con AI y campañas de Facebook Ads con la estructura que ya funciona.',
  },
  {
    number: '05',
    title: 'Cierra la venta',
    description:
      'Scripts de cierre para negocios locales y seguimiento automatizado desde tu CRM.',
  },
  {
    number: '06',
    title: 'Entrega con AI',
    description:
      'Tus Custom AI Brains ejecutan el trabajo operativo para que puedas cumplir sin ahogarte.',
  },
  {
    number: '07',
    title: 'Escala',
    description:
      'Optimizas con datos reales, subes presupuesto y repites el proceso con más clientes.',
  },
]

export const testimonials: Testimonial[] = [
  {
    name: 'Andrés M.',
    role: 'Freelance · Bogotá',
    quote:
      'Nunca había vendido nada online. Seguí el plan de 48 horas tal cual y cerré mi primer sitio web con un restaurante de mi zona.',
    result: 'Primer cliente en 6 días',
  },
  {
    name: 'Karla V.',
    role: 'Agencia de 1 persona · Monterrey',
    quote:
      'Lo que más me sirvió fueron los scripts y el CRM ya armado. Dejé de improvisar y empecé a dar seguimiento en serio.',
    result: '3 clientes recurrentes',
  },
  {
    name: 'Julio R.',
    role: 'Ventas B2B · Miami',
    quote:
      'Las llamadas de los miércoles valen el programa completo. Me revisaron los anuncios y corregí en el momento.',
    result: 'Bajó su costo por lead a la mitad',
  },
]

export const faqs: Faq[] = [
  {
    question: '¿Necesito experiencia previa con AI o marketing?',
    answer:
      'No. El sistema está diseñado para que empieces desde cero. Cada paso viene con plantillas, prompts y scripts listos para copiar; tu trabajo es ejecutar en el orden indicado.',
  },
  {
    question: '¿Cuánto tiempo necesito al día?',
    answer:
      'El plan está pensado para completarse en 48 horas de ejecución enfocada. La mayoría lo hace en 2 a 3 horas diarias durante la primera semana.',
  },
  {
    question: '¿El pago es único o mensual?',
    answer:
      'Es un pago único de $27. No hay suscripción, no hay cargos ocultos y el acceso a todos los módulos y bonos queda contigo.',
  },
  {
    question: '¿Cuándo recibo el acceso?',
    answer:
      'Inmediatamente después de la compra recibes por correo tus datos de acceso a la plataforma, a las plantillas y a la comunidad privada en SKOOL.',
  },
  {
    question: '¿Necesito invertir en anuncios?',
    answer:
      'No es obligatorio para empezar. El sistema incluye prospección orgánica con AI, y cuando decidas invertir tendrás el módulo completo de Facebook Ads para hacerlo con estructura.',
  },
  {
    question: '¿Qué pasa si no me sirve?',
    answer:
      'Tienes garantía de devolución total. Si no quedas completamente satisfecho, escribes al soporte y te devolvemos tu dinero. Sin preguntas.',
  },
]

export const offerSummary = [
  { label: '48 Hrs AI Cash Machine', value: '$497' },
  { label: 'AI Web Closer Academy', value: '$397' },
  { label: 'Facebook Ads Expert', value: '$297' },
  { label: 'Build AI Websites', value: '$297' },
  { label: 'The Ultimate AI Creator Bundle', value: '$247' },
  { label: 'Custom AI Brains', value: '$259' },
  { label: 'BONO: Llamadas en vivo (12 meses)', value: '$1,164' },
  { label: 'BONO: Website Templates con CRM', value: '$497' },
  { label: 'BONO: Comunidad privada en SKOOL', value: '$297' },
]

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/68d96cde-5f38-4b8d-8e89-d5104a401151.jpg'

export const CHECKOUT_URL =
  'https://commas.com/checkout/gQ88lpN7PKuMEe?affiliate_code=samuel22810'
